import moment from "moment";
// -
import IconBool from "components/IconBool";
import ConditionalRender from "components/ConditionalRender";

const SenderInfo = ({to, name, _TC, item, attr}) => {

    const TitleComponent = () => {
        if (to && name) {
            return <div><strong>{to}:</strong> <span>{name}</span></div>;
        } else if (to) {
            return <div><strong>{to}</strong></div>
        }
        return <div><span>{name}</span></div>
    }

    return (
        <ConditionalRender condition={item[attr + "_carry"]}>
            <div className="card d-inline-block py-2 px-3 m-2">
                <TitleComponent/>
                <ConditionalRender condition={item.queue_at}>
                    <div className="small">
                        <span>{moment(item.queue_at).format("DD-MM-YYYY hh:mm")}</span>
                    </div>
                </ConditionalRender>
                <div>
                <span title={_TC("confirm.sent")} className="me-2">
                    {_TC("confirm.sent.short") + " "} <IconBool value={item[attr + "_send"]}/>
                </span>
                    <span title={_TC("confirm.confirmed")}>
                    {_TC("confirm.confirmed.short") + " "} <IconBool value={item[attr + "_ack"]}/>
                </span>
                </div>
                <ConditionalRender condition={item[attr + "_cc_at"]} fallback="-">
                    <span>{moment(item[attr + "_cc_at"]).format("DD-MM-YYYY hh:mm")}</span>
                </ConditionalRender>
            </div>

        </ConditionalRender>
    )
}
export default SenderInfo